(() => {
  const script = document.querySelector('script[data-gf-cart-delivery]');
  const options = script?.dataset || {};
  const pending = new WeakSet();
  const approved = new WeakSet();
  function snapshot(state, labels) {
    const lines = new Map();
    for (const item of state.items) {
      const properties = Object.entries(item.properties || {}).filter(([name]) => !labels.has(name)).sort(([a], [b]) => a.localeCompare(b));
      const identity = JSON.stringify([item.variant_id, item.selling_plan_allocation?.selling_plan?.id || null, properties]);
      lines.set(identity, (lines.get(identity) || 0) + item.quantity);
    }
    return JSON.stringify({
      note:state.note || '',
      attributes:Object.entries(state.attributes || {}).sort(([a], [b]) => a.localeCompare(b)),
      currency:state.currency,count:state.item_count,total:state.total_price,
      lines:[...lines].sort(([a], [b]) => a.localeCompare(b))
    });
  }
  async function json(url, init = {}) {
    const response = await fetch(url, {credentials:'same-origin',cache:'no-store',...init});
    const data = await response.json();
    if (!response.ok || data.errors || data.status >= 400) throw new Error(options.error);
    return data;
  }
  async function prepare({cartUrl, changeUrl, sectionId, sectionsUrl = location.pathname, render}) {
    let state = await json(`${cartUrl}.js`, {headers:{'Accept':'application/json'}});
    const url = new URL(cartUrl, location.origin);
    url.searchParams.set('section_id', 'gf-cart');
    const response = await fetch(url, {credentials:'same-origin',cache:'no-store'});
    if (!response.ok) throw new Error(options.error);
    const root = new DOMParser().parseFromString(await response.text(),'text/html').querySelector('gf-cart');
    const estimates = new Map();
    for (const item of state.items) {
      const row = [...(root?.querySelectorAll('[data-cart-key]') || [])].find(element => element.dataset.cartKey === item.key);
      const delivery = row?.querySelector('[data-cart-delivery-name]');
      const name = delivery?.dataset.cartDeliveryName;
      const value = delivery?.dataset.cartDeliveryValue;
      if (!name || !value || Number(row.dataset.cartQuantity) !== item.quantity) throw new Error(options.error);
      const prior = estimates.get(item.variant_id);
      if (prior && (prior.name !== name || prior.value !== value)) throw new Error(options.error);
      estimates.set(item.variant_id, {name, value});
    }
    const labels = new Set([...estimates.values()].map(estimate => estimate.name));
    const original = snapshot(state, labels);
    const limit = state.items.length;
    for (let attempt = 0; attempt <= limit; attempt++) {
      const item = state.items.find(line => {
        const estimate = estimates.get(line.variant_id);
        if (!estimate) throw new Error(options.error);
        return !String(line.properties?.[estimate.name] || '').trim();
      });
      if (!item) return state;
      if (attempt === limit) throw new Error(options.error);
      const {name, value} = estimates.get(item.variant_id);
      const properties = {...(item.properties || {}), [name]:value};
      const body = {id:item.key,quantity:item.quantity,properties};
      if (sectionId) { body.sections = [sectionId]; body.sections_url = sectionsUrl; }
      const next = await json(changeUrl, {
        method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify(body)
      });
      if (snapshot(next, labels) !== original) throw new Error(options.error);
      const saved = next.items.some(line => line.variant_id === item.variant_id && Object.entries(properties).every(([key, entry]) => line.properties?.[key] === entry));
      if (!saved) throw new Error(options.error);
      state = next;
      if (render) render(state.sections);
    }
    throw new Error(options.error);
  }
  window.gfCartDelivery = {prepare};
  document.addEventListener('submit', async event => {
    const form = event.target;
    const submitter = event.submitter;
    if (!(form instanceof HTMLFormElement) || form.closest('gf-cart') || submitter?.name !== 'checkout') return;
    const action = new URL(form.action, location.origin);
    if (action.origin !== location.origin || action.pathname.replace(/\/$/,'') !== options.cartUrl) return;
    if (approved.has(form)) { approved.delete(form); return; }
    event.preventDefault();
    if (pending.has(form)) return;
    pending.add(form);
    const panel = form.closest('cart-notification, cart-drawer') || form;
    let status = panel.querySelector('[data-gf-cart-delivery-status]');
    if (!status) {
      status = document.createElement('p');
      status.dataset.gfCartDeliveryStatus = '';
      status.setAttribute('role','status');
      panel.append(status);
    }
    status.setAttribute('role','status');
    status.textContent = options.preparing;
    const disabled = submitter.disabled;
    submitter.disabled = true;
    form.inert = true;
    try {
      await prepare({cartUrl:options.cartUrl,changeUrl:options.changeUrl});
      submitter.disabled = disabled;
      form.inert = false;
      approved.add(form);
      form.requestSubmit(submitter);
    } catch {
      status.setAttribute('role','alert');
      status.textContent = options.error;
    } finally {
      approved.delete(form);
      pending.delete(form);
      submitter.disabled = disabled;
      form.inert = false;
    }
  }, true);
})();
